import { defaultCellStyle } from "./DataGridColumns";
import resources from "../../core/Localization/Localization";
import UserRoles from "../../auth/UserRoles";
import { Tooltip } from "@mui/material";
import { getDateString } from "../../utils/getDateString";
import { dangerColor } from "../../assets/jss/material-dashboard-react";


const offerCellStyle = {
    width: '100%',
    backgroundColor: dangerColor[0],
    textAlign: "center",
    fontWeight: "bold",
    color: "white",
};

export const userColumns = () => [
    {
        field: "id",
        headerName: "ID",
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "firstname",
        headerName: resources.userList.datagrid.firstname,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "lastname",
        headerName: resources.userList.datagrid.lastname,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "shop_name",
        headerName: resources.userList.datagrid.shop_name,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "email",
        headerName: resources.userList.datagrid.email,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1
    },
    {
        field: "role",
        headerName: resources.userList.datagrid.role,
        flex: 1,
        filterable: true,
        sortable: true,
        type: "singleSelect",
        valueOptions: Object.values(UserRoles).slice(1),
        renderCell: (params) => {

            const value = params.value;
            const row = params.row;

            if (row.role === 'Neverifikovan Prodavac' && !row.someOtherField) {
                return (
                    <div style={{ display: 'flex' }}>
                        <p style={offerCellStyle}>
                            {value}
                        </p>
                    </div>
                );
            }

            return (
                <Tooltip title={value} placement="bottom-start">
                    <div style={defaultCellStyle}>{value}</div>
                </Tooltip>
            );
        },
        flex: 1
    },
    {
        field: "createdAt",
        headerName: resources.partRequests.datagrid.created,
        filter: true,
        sort: true,
        filterType: "textField",
        flex: 1,
        valueGetter: (value) => getDateString(value)
    }
];
